import { client } from '../http';

export default {
  async publishAsyncFallback() {
    await client.post('/api/async-fallback');
  },
};
